import { BorderRadius, Color, getShadow } from '@billy/design-system'
import styled from '@emotion/styled'
import SimpleBar from 'simplebar-react'

export const ScrollableListWrapper = styled.div`
  height: 100%;
  border: 1px solid ${Color.Grey150};
  border-radius: ${BorderRadius.R12};
  ${getShadow('raisedLight')}
  overflow: hidden;
`

export const ScrollableListContent = styled(SimpleBar)`
  height: 100%;
`
